import { render, staticRenderFns } from "./PartyOnboardingBank.vue?vue&type=template&id=2203e5ea"
import script from "./PartyOnboardingBank.vue?vue&type=script&lang=js"
export * from "./PartyOnboardingBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports